module.exports = __webpack_public_path__ + "static/sunken-forest-2.375c6413.jpg";